import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { DpadKeyCode, DpadZoneType } from '@core/constants';
import { DpadZoneState } from '@core/models/models';
import { DpadControlService } from '@core/services/common/dpad-control.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'caremoni-scroll-selector',
  templateUrl: './scroll-selector.component.html',
  styleUrl: './scroll-selector.component.scss',
  encapsulation: ViewEncapsulation.None
})

export class TvScrollSelectorComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() list: any[] = [];
  @Input() dpadZone: number = DpadZoneType.SCREEN;
  @Input() textEmpty: string = "";
  @Input() thresholdIndex: number = 4; // Index Bắt đầu animation scroll của TV.
  @Output() onSelectItemHandle = new EventEmitter();

  @ViewChild('scrList') listRef!: ElementRef<HTMLDivElement>;
  @ViewChild('scrHighlight') highlightRef!: ElementRef<HTMLDivElement>;
  @ViewChild('scrPicker') pickerRef!: ElementRef<HTMLDivElement>;

  subscription: Subscription = new Subscription();
  visible: number = 0;// số item hiển thị
  index: number = 0;
  itemHeight: number = 0;
  translate: number = 0;

  constructor(
      private dpadControlService: DpadControlService,
  ) {}

  ngOnInit(): void {
    this.dpadControlService.setOnBackDPad(()=>{
      if (this.list.length > 0) {
        this.moveHighlight(0);
      }
    });
    [
      this.dpadControlService.dZoneState$.subscribe((state: DpadZoneState) => {
        if (state.dZone === this.dpadZone) { this.moveHighlight(state.dY); }
      })
    ].forEach(sub => this.subscription.add(sub));
  }
  
  ngOnDestroy(): void { this.subscription.unsubscribe(); }

  ngAfterViewInit(): void {
    const firstItem = this.listRef.nativeElement.querySelector('.scr-sl-item') as HTMLElement;
    if (firstItem) {
      this.itemHeight = firstItem.offsetHeight;
    }
    // Tính số item hiển thị dựa trên chiều cao thực của picker
    this.visible = Math.floor(this.pickerRef.nativeElement.clientHeight / this.itemHeight);
    // Đảm bảo thresholdIndex < visible
    this.thresholdIndex = Math.min(this.thresholdIndex, Math.max(0, this.visible - 1));

    this.moveHighlight(0);
  }

  private limitIndexRange(value: number, min: number, max: number): number {
    return Math.max(min, Math.min(max, value));
  }

  moveHighlight(i: number) {
    if (!this.listRef || !this.highlightRef) {
      return;
    }
    const total = this.list.length;
    this.index = this.limitIndexRange(i, 0, total - 1);

    const posFixed = this.thresholdIndex * this.itemHeight;
    const minTranslate = -Math.max(0, (total - this.visible) * this.itemHeight);

    const desiredTranslate = -this.index * this.itemHeight + posFixed;
    this.translate = this.limitIndexRange(desiredTranslate, minTranslate, 0);

    const highlightTop = this.index * this.itemHeight + this.translate;

    this.listRef.nativeElement.style.transform = `translate3d(0, ${this.translate}px, 0)`;
    this.highlightRef.nativeElement.style.top = `${highlightTop}px`;
  }

  onSelectItem(idx: number) {
    this.onSelectItemHandle.emit(idx);
  }
}
